<section
  class="flex min-h-0 flex-1 flex-col px-3 pt-3"
  [class.overflow-hidden]="phase() === 'clarifying'"
  [class.pb-3]="phase() !== 'clarifying'"
  [class.pb-0]="phase() === 'clarifying'"
>
  @if (!hasAccess()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-10 text-center">
      <button
        type="button"
        class="rounded-lg border border-[#ece4f3] px-4 py-2 text-sm font-medium text-[#5a2f6b]"
        (click)="backToList()"
      >
        {{ "mobile.voiceReport.workflow.backToList" | translate }}
      </button>
    </div>
  } @else if (errorMessageKey() && phase() === "recorder") {
    <div class="flex flex-1 flex-col items-center justify-center gap-4 rounded-2xl border border-destructive/20 bg-destructive/5 px-4 py-10 text-center">
      <span class="material-icons text-[40px] text-destructive" aria-hidden="true">error_outline</span>
      <p class="text-sm text-destructive">{{ errorMessage() }}</p>
      <button
        type="button"
        class="rounded-lg bg-[#5a2f6b] px-4 py-2 text-sm font-semibold text-white"
        (click)="clearError()"
      >
        {{ "common.retry" | translate }}
      </button>
    </div>
  } @else if (phase() === "recorder" && isSubmitting()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-4 py-16 text-center">
      <span class="material-icons animate-pulse text-[48px] text-[#5a2f6b]" aria-hidden="true">hourglass_top</span>
      <p class="text-sm text-[#7a6b8a]">{{ "mobile.aiQuestionnaire.workflow.submitting" | translate }}</p>
    </div>
  } @else if (phase() === "clarifying") {
    @if (errorMessageKey()) {
      <div class="mb-3 rounded-xl border border-destructive/20 bg-destructive/5 px-3 py-2 text-center text-sm text-destructive">
        {{ errorMessage() }}
      </div>
    }
    <mobile-ai-questionnaire-clarify-chat
      class="min-h-0 flex-1"
      [messages]="clarifyMessages()"
      [requiresMoreClarification]="requiresMoreClarification()"
      [loading]="isSubmitting()"
      [contextLabel]="sessionLabel()"
      (answerSubmitted)="onClarifyAnswer($event)"
      (generateRequested)="onGenerateDraft()"
      (recordError)="onRecordError($event)"
    />
  } @else {
    @if (errorMessageKey()) {
      <div class="mb-3 rounded-xl border border-destructive/20 bg-destructive/5 px-3 py-2 text-center text-sm text-destructive">
        {{ errorMessage() }}
      </div>
    }
    <mobile-voice-purchase-request-recorder
      class="min-h-0 flex-1"
      [contextLabel]="sessionLabel()"
      infoTitleKey="mobile.aiQuestionnaire.recorder.infoTitle"
      infoBodyKey="mobile.aiQuestionnaire.recorder.infoBody"
      (recordError)="onRecordError($event)"
      (sent)="onInitialSent($event)"
    />
  }
</section>
